export default function getCellStyleProperties(cell) {
  var align = cell.align,
      alignVertical = cell.alignVertical,
      fontFamily = cell.fontFamily,
      fontSize = cell.fontSize,
      fontWeight = cell.fontWeight,
      fontStyle = cell.fontStyle,
      wrap = cell.wrap,
      color = cell.color,
      backgroundColor = cell.backgroundColor,
      borderColor = cell.borderColor,
      borderStyle = cell.borderStyle,
      leftBorderColor = cell.leftBorderColor,
      leftBorderStyle = cell.leftBorderStyle,
      rightBorderColor = cell.rightBorderColor,
      rightBorderStyle = cell.rightBorderStyle,
      topBorderColor = cell.topBorderColor,
      topBorderStyle = cell.topBorderStyle,
      bottomBorderColor = cell.bottomBorderColor,
      bottomBorderStyle = cell.bottomBorderStyle;

  if (align || alignVertical || fontFamily || fontSize || fontWeight || fontStyle || wrap || color || backgroundColor || borderColor || borderStyle || leftBorderColor || leftBorderStyle || rightBorderColor || rightBorderStyle || topBorderColor || topBorderStyle || bottomBorderColor || bottomBorderStyle) {
    return omitUndefinedProperties({
      align: align,
      alignVertical: alignVertical,
      fontFamily: fontFamily,
      fontSize: fontSize,
      fontWeight: fontWeight,
      fontStyle: fontStyle,
      wrap: wrap,
      color: color,
      backgroundColor: backgroundColor,
      borderColor: borderColor,
      borderStyle: borderStyle,
      leftBorderColor: leftBorderColor,
      leftBorderStyle: leftBorderStyle,
      rightBorderColor: rightBorderColor,
      rightBorderStyle: rightBorderStyle,
      topBorderColor: topBorderColor,
      topBorderStyle: topBorderStyle,
      bottomBorderColor: bottomBorderColor,
      bottomBorderStyle: bottomBorderStyle
    });
  }
}

function omitUndefinedProperties(object) {
  var filteredObject = {};

  for (var key in object) {
    if (object[key] !== undefined) {
      filteredObject[key] = object[key];
    }
  }

  return filteredObject;
}
//# sourceMappingURL=getCellStyleProperties.js.map